export default __webpack_public_path__ + "static/media/installing-nodejs-on-your-device.b185d176.md";